import React from 'react';
import {FiArrowRight} from 'react-icons/fi';


const NavCard: React.FC = () => {
    return (
        <>
            <div className="bg-[#6792FF] rounded-xl w-fit p-6 flex flex-col items-start mt-24 mx-auto">
                <div className="flex flex-col mb-6 text-white">
                    <span className='text-white'> Having any</span>
                    <span>Problem?</span>
                </div>
                <button className='bg-white text-blue-500 px-3 py-2 rounded-2xl'>Contact Support</button>

            </div>
            <div className="w-full mt-16 mb-6">
                <button className="w-4/5 text-white flex items-center justify-center"><span className='mr-2'>Log out</span> <FiArrowRight /> </button>
            </div>
        </>

    );
}
export default NavCard;